import React from 'react';
import { SETTING } from 'interfaces/settings';
import { Typography } from 'interfaces/typography';
import { useAutodialerSettings } from '../hooks/useAutodialerSettings';
import { Lock } from 'lucide-react';

interface LockedSettingDisplayProps {
    setting: SETTING;
    isInMultiRow?: boolean;
}

export function LockedSettingDisplay({ setting, isInMultiRow = false }: LockedSettingDisplayProps) {
    const { getValueForSetting, formatSettingValue } = useAutodialerSettings();
    const value = getValueForSetting(setting);
    
    // Compact version for multi-row
    if (isInMultiRow) {
        return (
            <div className="flex-1 h-full">
                <div className="flex items-center justify-center gap-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 h-full">
                    <Lock size={12} className="text-gray-500" />
                    {value !== null && (
                        <Typography variant="smallParagraph" color="#374151" fontWeight="500">
                            {formatSettingValue(setting, value)}
                        </Typography>
                    )}
                </div>
            </div>
        );
        }

    return (
        <div className="flex items-center gap-4 h-full">
            <div className="flex items-center gap-2 bg-gray-50 px-2 py-1 rounded border border-gray-200 flex-1 min-h-0">
                <Lock size={14} className="text-gray-500 flex-shrink-0" />
                {value !== null && (
                    <Typography variant="smallParagraph" color="#374151" fontWeight="500">
                        {formatSettingValue(setting, value)}
                    </Typography>
                )}
                <Typography variant="smallParagraph" color="#6b7280" fontWeight="500" className="px-1.5 py-0.5 bg-gray-100 rounded flex-shrink-0">
                    Locked
                </Typography>
            </div>
            <Typography variant="smallParagraph" color="#6b7280" fontWeight="500" className="flex-shrink-0">
                Admin must unlock or set
            </Typography>
        </div>
    );
} 